export enum LayoutOrientation {
  List = "list",
  Grid = "grid"
}
